import { Agent } from "../../apis/agent.api";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

interface State extends Partial<Agent> {
  userId?: string;
  isTemp?: boolean;
}

const initialState: State = {
  id: "",
  isTemp: true,
};

const tempUserSlice = createSlice({
  name: "temp-user-slice",
  initialState,
  reducers: {
    setTempAgent: (state, action: PayloadAction<State>) => {
      state.id = action.payload.id;
      state.userId = action.payload.userId;
      state.agent_name = action.payload.agent_name;
      state.created_at = action.payload.created_at;
      state.is_deployed = action.payload.is_deployed;
      state.model_name = action.payload.model_name;
      state.temperature = action.payload.temperature;
      state.isTemp = action.payload.isTemp;

      if (typeof window !== "undefined") {
        Cookies.set("isTempUser", String(state.isTemp), {
          secure: process.env.NODE_ENV === "production",
          sameSite: "lax",
          expires: 7,
        });
      }
    },
    clearTempData: (state) => {
      Object.keys(state).forEach((key) => {
        state[key as keyof State] = undefined;
      });
      // state.isTemp = true;
    },
  },
});

export const { setTempAgent, clearTempData } = tempUserSlice.actions;
export default tempUserSlice.reducer;
